<template>
  <div>
    <Bubble>
      <!-- <vue-headful title="Termine - Dachaudenktweiter"/> -->
      <div class="row">
        <div class="col">
          <Typo>
            <template slot="header">
              Herzlich Willkommen!
            </template>
            <template slot="main">
              Wir freuen uns, Sie zu den öffentlichen Terminen begrüßen zu dürfen
            </template>
          </Typo>
        </div>
        <div class="col-3">
          <img src="@/assets/grafiken/bild_termine-1.png">
        </div>
      </div>
        <div class="row">
        <div class="col-push"></div>
        <div class="col-3-center">
          <p>Im Rahmen dieser Website werden Termine zu Veranstaltungen und Beteiligungen veröffentlicht. 
          Derzeit befindet sich das Projekt in der Startphase. Es finden verwaltungsinterne Abstimmungen sowie Einzelgespräche mit Multiplikatoren statt.</p><p>Gerne können Sie aber über die <router-link to="/machmit">"Mach-Mit"</router-link>-Rubrik uns wichtige Informationen schon frühzeitig mitteilen.</p>
          <!-- <h1>Öffentliche Termine</h1>
          <p>Über öffentliche Termine im Rahmen des Projekten werden wir laufend an dieser Stelle informieren.</p> -->
        </div>
      </div>
    </Bubble>
  </div>
</template>

<script>
import Bubble from "@/components/Bubble.vue";

export default {
  metaInfo: {
    title: "Termine"
  },
  components: {
    Bubble
  }
};
</script>

<style scoped lang="scss">
img {
  width: 100% !important;
  // max-width: 800px;
}
</style>

